module.exports = __webpack_public_path__ + "static/media/288702.0c78bb87.svg";